<template>
  <section class="ml-switcher">
    <div class="ml-buttons" ref="buttonContainer">
      <div
        class="button-wrapper"
        v-for="(option, index) in options"
        :key="option.ml"
      >
        <button
          :ref="el => buttonRefs[index] = el"
          :class="{ active: current === option.ml }"
          @click="switchML(option.ml, index)"
        >
          {{ option.label }}
        </button>
      </div>
      <div class="underline" :style="underlineStyle"></div>
    </div>

    <transition name="fade">
      <div class="product-display" :key="current">
        <img :src="images[current]" :alt="current" />
      </div>
    </transition>
  </section>
</template>

<script>
import Img07ml from '@/assets/images/product/TSY/0.7ml.png'
import Img1ml from '@/assets/images/product/TSY/1ml.png'

export default {
  data() {
    return {
      current: '1ml',
      currentIndex: 1,
      buttonRefs: [],
      underline: { left: 0, width: 0 },
      options: [
        { ml: '0.7ml', label: '0.7 mL' },
        { ml: '1ml', label: '1 mL' }
      ],
      images: {
        '0.7ml': Img07ml,
        '1ml': Img1ml,
      }
    }
  },
  computed: {
    underlineStyle() {
      return {
        left: this.underline.left + 'px',
        width: this.underline.width + 'px'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderline(this.currentIndex)
    })
    window.addEventListener('resize', () => {
      this.updateUnderline(this.currentIndex)
    })
  },
  methods: {
    switchML(ml, index) {
      if (this.current !== ml) {
        this.current = ml
        this.currentIndex = index
        this.updateUnderline(index)
      }
    },
    updateUnderline(index) {
      const btn = this.buttonRefs[index]
      if (btn) {
        this.underline.left = btn.offsetLeft
        this.underline.width = btn.offsetWidth
      }
    }
  }
}
</script>

<style scoped>
.ml-switcher {
  padding: 4rem 2rem;
  text-align: center;
}

.ml-buttons {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.button-wrapper {
  margin: 0 0.5rem;
}

.ml-buttons button {
  padding: 0.8rem 1.5rem;
  font-size: 1.2rem;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #666;
}

.ml-buttons button.active {
  transform: scale(1.05);
  color: #111;
  font-weight: bold;
}

.ml-buttons .underline {
  position: absolute;
  bottom: 0;
  height: 3px;
  background: #333;
  transition: all 0.3s ease;
}

.product-display img {
  max-width: 100%;
  height: auto;
}

/* 淡入動畫 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
